<template>
  <el-card class="model-tree p-10px absolute w-368px right-35px top-50px z-99 color-white !border-none !bg-[#2e6bb080]">
    <div slot="header">
      <div class="flex justify-between items-center mb-10px">
        <span class="text-14px">模型树</span>
        <span class="text-14px el-icon-close " @click="$emit('closeComponents')"></span>
      </div>
    </div>
    <div class="h-38px p-5px">
      <el-input
        size="small"
        placeholder="请输入要过滤的设备"
        v-model="filterTreeKeyWords"
        @keypress.native.enter="filterModelTree(0, true, filterTreeKeyWords, 0)"
        clearable
      >
        <span
          slot="append"
          class="p-10px el-icon-arrow-down cursor-pointer"
          @click="filterModelTree(currentNodeItem, true, filterTreeKeyWords, 0)"
        ></span>
        <span
          slot="append"
          class="p-10px el-icon-arrow-up cursor-pointer"
          @click="filterModelTree(currentNodeItem, false, filterTreeKeyWords, 0)"
        ></span>
      </el-input>
    </div>
    <div class="w-full h-full mt-5px">
      <el-tree
        :props="treeProps"
        ref="modelTree"
        :load="loadNode"
        highlight-current
        :lazy="true"
        show-checkbox
        :default-checked-keys="checkedKeys"
        :default-expanded-keys="defaultExpandedKeys"
        :filter-node-method="filterNode"
        :expand-on-click-node="false"
        @node-click="clickModelTree"
        @check="checkModelTree"
        node-key="item"
      ></el-tree>
    </div>
  </el-card>
</template>

<script>

export default {
  name: 'modelTreeDialog',
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    modelTreeProp: {
      type: Object,
      default: () => {
        return {
          currentNodeItem: 0, // 当前激活的node
          currentNodeName: '', // 点选时当前激活的节点名称
          treeData: [], // 模型树数据
          defaultCheckedKey: [], // 模型树选中的节点
          filterItem: [], // 模型树不需要显示的节点及他的父节点列表
          modelHideList: [], // 模型隐藏队列
        }
      },
    },
  },
  watch: {
    'modelTreeProp.defaultCheckedKey': {
      handler(val) {
        this.checkedKeys = val
        if (this.$refs.modelTree) {
          this.defaultCheckedKeys = val
          this.$refs.modelTree.setCheckedKeys(this.checkedKeys)
        }
      },
      immediate: true,
    },
    'modelTreeProp.currentNodeItem': {
      handler(val) {
        this.currentNodeItem = val
      },
      immediate: true,
    },
    'modelTreeProp.currentNodeName': {
      handler(val) {
        if (val) {
          if (this.currentNodeName === val) return
          this.currentNodeName = val
          this.filterModelTree(0, true, val, 3)
        }
      },
    },
  },
  created() {
    this.getModelTreeDatas()
  },
  data() {
    return {
      modelTreeVisbile: true, // 模型树的显示
      filterTreeKeyWords: '', // 过滤模型树关键字
      currentNodeItem: 0, // 当前激活的node
      defaultExpandedKeys: [], // 展开节点
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      currentNode: null, // 查询到模型树节点
      currentNodeName: '', // 点选时当前激活的节点名称
      checkedKeys: [],
      modelTreeObj: {
        ITEM_PR: 0, // PR 文件节点类型
        ITEM_NODE: 1, // CELLNode文件节点类型
        ITEM_GISOBJ: 2, // gis 数据对象
        ITEM_NULL: 3, // 仅仅对根节点使用
      },
    }
  },
  methods: {
    checkModelTree(data, checkeds) {
      // 节点选中状态发生变化
      const isChecked = _.includes(checkeds.checkedKeys, data.item)
      this.$emit('setModelVisible', 'checkModelTree', isChecked, data, checkeds)
    },
    // 模型树点击操作
    clickModelTree(data, node) {
      if (!node.checked) return
      this.player.Native.ModelTree.setSelectItem(data.item)
      this.player.Native.Camera.moveToItem(data.item, 1)
      this.currentNodeItem = data.item
      this.currentNodeName = data.name
    },
    // 模型树加载
    async loadNode(node, resolve) {
      let tempFilterKeys = _.filter(this.modelTreeProp.treeData, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.item) === -1
      })
      if (node.level === 0) {
        this.modelTreeProp.defaultCheckedKey = _.map(tempFilterKeys, (val) => {
          return val.item
        })
        return resolve(this.modelTreeProp.treeData)
      }
      const res = await PlayerUtils.call(this.player.Native.ModelTree.getSubItems, node.data.item)
      // console.log(res, '_________PlayerSubs')
      const filterRes = _.filter(res, (el) => {
        return el.name && el.visible
      })
      // 控制模型树的选中按钮
      tempFilterKeys = _.filter(filterRes, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.item) === -1
      })
      const tempCheckedKey = _.map(tempFilterKeys, (val) => {
        return val.item
      })
      // 过滤勾选状态为选中的子集
      const checkedKeys = _.map(
        _.filter(filterRes, (res4) => {
          return res4.checked
        }),
        (res5) => {
          return res5.item
        }
      )
      // 查看当前节点是否没有在影藏队列
      // 保存this指向
      const _this = this
      const isNoFindModelHides = function (nodeObj) {
        return (
          _.indexOf(
            _.map(_this.modelTreeProp.modelHideList, (res1) => {
              return res1.item
            }),
            nodeObj.data.item
          ) === -1
        )
      }
      if (isNoFindModelHides(node)) {
        // 没有在影藏队列中
        let node1 = node
        while (node1.level !== 0) {
          // 向上查找没有在影藏队列的父辈节点
          if (isNoFindModelHides(node1)) {
            node1 = node1.parent
          } else {
            // 父级在影藏队列就结束向上查找
            break
          }
        }
        if (node1.level === 0) {
          // 如果查找到跟节点都没有在影藏队列中，那么就代表全是勾选状态，不存在半选
          this.modelTreeProp.defaultCheckedKey = [
            ...this.modelTreeProp.defaultCheckedKey,
            ...tempCheckedKey,
          ]
        } else {
          // 中间父级可能是半选或者空白
          // 通过父获取子集的状态,如果子集中有一个为false，那么就把父级从默认选中框中去除掉，然后在设置子集节点状态
          if (_.some(filterRes, { checked: false })) {
            this.modelTreeProp.defaultCheckedKey = [
              ..._.filter(this.modelTreeProp.defaultCheckedKey, (val) => {
                return val !== node.data.item
              }),
              ...checkedKeys,
            ]
          }
        }
      } else {
        // 在隐藏队列表
        this.modelTreeProp.defaultCheckedKey = [
          ...this.modelTreeProp.defaultCheckedKey,
          ...checkedKeys,
        ]
      }
      resolve(filterRes)
      _.forEach(filterRes, (el) => {
        if (this.currentNode && this.currentNode.item) {
          if (el.item === this.currentNode.item) {
            this.locationNode(this.currentNode.item)
          }
        }
      })
      if (this.modelTreeProp.defaultCheckedKey) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      }
    },
    async filterModelTree(startItem, direction, KeyWords, type, doLocation = true) {
      // 过滤模型树
      this.currentNode = await PlayerUtils.call(
        this.player.Native.ModelTree.findItemByName,
        KeyWords, // 关键字
        startItem, // 开始查询的树节点
        direction, // 遍历方向
        type // 0 包含text子串,1 以text开头,2 以text结尾,3 与text相等
      )
      // 展开树
      if (!_.isEmpty(this.currentNode)) {
        await this.expendNode(this.currentNode, doLocation)
      } else {
        // 未找到
        this.$message.error('搜索结果到底了')
      }
    },
    // 展开节点树
    async expendNode(node, doLocation) {
      // item: 1为pr模型跟， node.parentItem = 0为杆塔模型的跟
      if (node.item === 1 || node.parentItem === 0) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          if (!this.currentNodeName) {
            // 无激活节点时
            this.clickModelTree(this.currentNode, { checked: this.currentNode.checked }, doLocation)
          }
          // 有选中激活节点时
          this.currentNodeName = ''
          this.locationNode(this.currentNode.item)
        })
      } else {
        const res = await PlayerUtils.call(
          this.player.Native.ModelTree.getItemInfo,
          node.parentItem
        )
        await this.expendNode(res)
        // 展开
        this.defaultExpandedKeys.push(res.item)
      }
    },
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
    locationNode(id) {
      setTimeout(() => {
        this.$refs.modelTree.setCurrentKey(id)
      }, 800)
      setTimeout(() => {
        const currentNode = document.getElementsByClassName('is-current')[0]
        currentNode?.scrollIntoView({
          block: 'center',
        })
      }, 1000)
    },
    // 获取模型树数据
    async getModelTreeDatas() {
      // 删除地球GIS层
      this.modelTreeProp.treeData = _.filter(this.modelTreeProp.treeData, (item) => {
        return (
          item.itemType === this.modelTreeObj.ITEM_PR ||
          item.itemType === this.modelTreeObj.ITEM_NODE
        )
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  background: none !important;
  border: none !important;
  &__header {
    border-bottom: none;
    color: #fff;
    padding: 0px !important;
    background: none !important;
  }
  &__body {
    padding: 0 !important;
    height: calc(100% - 25px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    border-radius: 2px;
  }
}
::v-deep .el-input {
  &-group__append {
    background: rgba(24, 41, 72, 0.5) !important;
    border: none !important;
    color: #fff;
    padding: 0px !important;
  }
  &__inner {
    font-size: 12px;
    border-radius: 0px;
    background-color: rgba(24, 41, 72, 0.5) !important;
    padding: 0 10px;
    color: #fff !important;
    border: none;
    border-radius: 2px;
  }
}
::v-deep .el-tree {
  height: calc(100vh - 350px);
  overflow-y: scroll;
  &-node__label {
    font-size: 12px;
    color: #fff;
  }
  &-node__content {
    height: 28px;
  }
  &__empty-text {
    font-size: 12px;
    color: #fff !important;
  }
  .is-current{
    .el-tree-node__children .el-tree-node__label {
      color: #fff;
    }
  }
}
::v-deep .el-tree,
::v-deep .el-tree-node:focus > .el-tree-node__content,
::v-deep .el-tree-node:focus,
::v-deep .el-tree-node__content:hover,
::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: transparent;
}
::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgba(0,116,201,0.4);
  color: #00c0ff;
}
::-webkit-scrollbar {
  width: 8px;
  background-color: rgba(53, 52, 52, 0);
}
::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: #2b323a;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
}
</style>
